<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add" v-loading="loading">
    <el-tabs v-model="activeName">
      <el-tab-pane label="基础" name="basic"></el-tab-pane>
      <el-tab-pane label="详情" name="content"></el-tab-pane> <!-- spec -->
      <el-tab-pane label="折扣" name="spec"></el-tab-pane> <!-- attr -->
      <el-tab-pane label="权限" name="relationproduct"></el-tab-pane> <!-- content -->
      <el-tab-pane label="分销" name="relationlabel"></el-tab-pane> <!-- relationproduct 关联商品-->
      <el-tab-pane label="参数" name="attr"></el-tab-pane> <!-- relationlabel 关联标签 -->
      <el-tab-pane label="高级" name="buyset"></el-tab-pane> <!-- buyset -->
      <el-tab-pane label="云仓" name="storage" v-if="form.storage_vars && form.storage_vars.is_open_storage"></el-tab-pane> <!-- storage -->
    </el-tabs>
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
      <!--基础信息-->
      <Basic v-if="activeName === 'basic'"></Basic>

      <!--规格设置-->
      <Spec v-if="activeName === 'spec'"></Spec>

      <!--商品详情-->
      <Content v-if="activeName === 'content'"></Content>
      <!--商品属性-->
      <Attr v-if="activeName === 'attr'" :type="'edit'"></Attr>
      <!--购买权限-->
      <Auth v-if="activeName === 'relationproduct'"></Auth>
      <!-- 分销模块 -->
      <commission v-if="activeName === 'relationlabel'"></commission>
      <!--高级设置-->
      <BuySet v-if="activeName === 'buyset'"></BuySet>
      <!--云仓设置-->
      <Storage v-if="activeName === 'storage'"></Storage>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :disabled="save_loading">发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import {formatModel} from '@/utils/base.js';
import Basic from './part/Basic.vue';
import Spec from './part/Spec.vue';
import Content from './part/Content.vue';
import BuySet from './part/Buyset.vue';
import Storage from './part/Storage.vue';
import Attr from './part/attr.vue';
import Commission from './part/Commission'
import Auth from './part/Auth'

export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    BuySet,
    // 商品属性
    Attr,
    // 分销模块
    Commission,
    // 商品购买权限
    Auth,
    Storage,
  },
  data() {
    return {
      activeName: 'basic',
      /*商品ID*/
      product_id: 0,
      /*判断是编辑*/
      scene: 'edit',
      /*是否正在加载*/
      loading: true,
      /*是否正在提交保存*/
      save_loading: false,
      /*form表单数据*/
      form: {
        // 时间对象
        timer: '',
        model: {
          list: [],
          attr_type: '',
          product_plus_image:''
        },

        /*商品分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        // 品牌
        brand: [],
        /*会员等级*/
        gradeList: [],
        product_del_ids: [],
        tableData: [],
        // 标签
        labelList: [],
        all_type: [],
        product_label_del_ids: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,

        commission_list: [],
        supply_price_name: "成本价",
        product_vars:{
          product_no_text: '',
          product_diy_no_text: '',
        },
        show_delivery: {
          show_store: false,
          show_storage: false,
        },
      },
      /*模型数据*/
      model: {
        /*商品名称*/
        product_name: '',
        product_days: '',
        /*商品配送方式 */
        delivery_type: [],
        /*商品编码*/
        product_no: '',
        /*商品内部编码*/
        product_diy_no: '',
        /*商品分类*/
        category_id: null,
        /*商品类型*/
        type: 'product',
        // 品牌
        brand_id: null,
        province_id: '',
        city_id: '',
        /*商品图片*/
        image: [],
        /*商品卖点*/
        selling_point: '',
        /*规格类别,默认10单规格，20多规格*/
        spec_type: 10,
        /*库存计算方式,默认20付款减库存，10下单减库存*/
        deduct_stock_type: 20,
        /*检查用户等级*/
        is_alone_grade: 0,
        /*单规格*/
        sku: {
          /*产品价格*/
          product_price: 0,
          /*产品供货价格*/
          product_supply_price: 0,
          // 最低渠道价
          agent_min_price: 0,
          // 最高渠道价
          agent_max_price: 0,
          /*产品划线价*/
          line_price: 0,
          /*库存数量*/
          stock_num: 100,
          /*商品重量*/
          product_weight: '0',
        },
        /*多规格类别*/
        spec_many: {
          /*多规格类别*/
          spec_attr: [],
          /*多规格表格数据*/
          spec_list: []
        },
        /*商品详情内容*/
        content: '',
        /*运费模板ID*/
        delivery_id: '',
        /*商品状态*/
        product_status: 10,
        // 商品链接状态
        link_status: 2,
        // 链接显示开始时间
        link_start_at: '',
        // 链接显示结束时间
        link_end_at: '',
        /*初始销量*/
        sales_initial: 0,
        /*商品排序，默认100*/
        product_sort: 100,
        /*是否开启积分赠送,默认1为开启，0为关闭*/
        is_points_gift: 1,
        /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
        is_points_discount: 1,
        /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
        is_enable_grade: 1,
        /*是否开启单独分销,默认0为关闭，1为开启*/
        is_ind_agent: 0,
        /*分销佣金类型,默认10为百分比，20为固定金额*/
        agent_money_type: 10,
        /*分销佣金类型,默认10为普通设置，20为详细设置*/
        agent_type: 10,
        /*一级佣金*/
        first_money: null,
        /*二级佣金*/
        second_money: null,
        /*三级佣金*/
        third_money: null,
        /* 按钮名称 */
        mini_name: '',
        /* 小程序id */
        mini_appid: '',
        /* 跳转页面 */
        mini_page: '',
        /* 商品直推佣金 */
        direct_commission: 0,
        /*是否虚拟商品*/
        is_virtual: 0,
        is_special_view: 0,
        /*编码批次*/
        code_product_open: 0,
        /*开启云仓配送*/
        open_storage: 0,
        /*强制开启云仓配送*/
        force_open_storage: 0,
        // 平台链接
        link: '',

        // 备注
        // remark:'',
        // 是否上下架
        automatic_shelves: 0,
        // 上下架时间
        shelves_time: [],
        //预售时间
        sale_time: '',
        //发货时间
        delivery_time: '',
        setting: {
          buy_auth: {
            show_price_id: [],
            buy_auth_id: [],
            tips: '无权限',
            name: '跳转连接',
            linkUrl: '',
            // 每月限购数量
            monthLimit: '',
          },
          text: {
            buy_text: '立即购买',
          }
        },
        commission_type: [],
        //限制购买
        buy_limit: 0,
        // 商品业绩
        achievement: 0,
        // 商品起购数
        buy_num: 0,
        video: '',
        poster: '',
        subtitle: '',
        page_id:'',
        grade_model: 0,
        is_level_difference: 0,
        lateral_ratio: 0,
        is_lateral: 0,
        is_full_return: 0,
      }
    };
  },
  provide: function () {
    return {
      form: this.form
    };
  },
  created() {
    /*获取列表*/
    this.product_id = this.$route.query.product_id;
    this.scene = this.$route.query.scene;
    this.getData();
  },
  methods: {
    /**
     * 获取基础数据
     */
    getData: function () {
      let self = this;
      PorductApi.getEditData(
        {
          product_id: self.product_id,
          scene: self.scene
        },
        true
      )
        .then(res => {
          self.loading = false;
          /*单独产品折扣*/
          if (res.data.model.alone_grade_equity != null && typeof res.data.model.alone_grade_equity != 'undefined' && res.data.model.is_alone_grade == 1) {
            let equitys = res.data.model.alone_grade_equity;
            res.data.gradeList.forEach(item => {
              item.product_equity = equitys[item.grade_id];
            });
          }
          /*固定金额 */
          if (res.data.model.alone_grade_equity != null && typeof res.data.model.alone_grade_equity != 'undefined' && res.data.model.is_alone_grade == 2) {
            let equitys = res.data.model.alone_grade_equity;
            res.data.gradeList.forEach(item => {
              item.product_fixed = equitys[item.grade_id];
            });
          }

          /*详细独立分销佣金 */
          if (res.data.model.agent_money_type != null && typeof res.data.model.independent_commission != 'undefined' && res.data.model.agent_money_type == 30) {
            let independent_commission = res.data.model.independent_commission;
            res.data.gradeList.forEach(item => {

              if (independent_commission[item.grade_id]) {

                item.independent_commission = independent_commission[item.grade_id];

              }

            });
          }
        // 独立平级奖励设置
          let equitys = res.data.model.lateral_ratio?JSON.parse(res.data.model.lateral_ratio):[];
          res.data.gradeList.forEach(item => {
            if(equitys && equitys[item.grade_id]){
              item.product_lateral_ratio = equitys[item.grade_id];
            } else {
              item.product_lateral_ratio = 0;
            }
          });

          res.data.relation_product.forEach(rp => {
            rp.product_image = rp.image[0]['file_path']
          })
          Object.assign(self.form, res.data);
          console.log(self.form.gradeList)
          self.form.gradeList = res.data.gradeList;
          self.form.timer = res.data.model.time;
          self.form.tableData = res.data.relation_product;
          self.form.labelList = res.data.relation_label
          self.form.product_del_ids = [];
          self.form.product_label_del_ids = [];
          self.form.storage_vars = res.data.storage_vars;
          self.form.product_vars = res.data.product_vars;
          if (!self.form.product_vars.product_no_text) {
            self.form.product_vars.product_no_text = '商品编码';
          }
          if (!self.form.product_vars.product_diy_no_text) {
            self.form.product_vars.product_diy_no_text = '商品自编码';
          }
          if (!self.form.supply) {
            self.form.no_supply = true
          } else {
            self.form.no_supply = self.form.supply.self_manage > 0;
          }
          if (!res.data.model.setting) {
            self.form.model.setting = {
              buy_auth: {
                show_price_id: [],
                buy_auth_id: [],
                tips: '',
                name: '跳转连接',
                linkUrl: ''
              }
            };
          }
          self.form.supply_price_name = self.form.no_supply ? '成本价' : '供货价';
          self.form.product_vars.product_no_text += "：";
          self.form.product_vars.product_diy_no_text += "：";
          if (res.data.specData) {
            self.$set(self.form.model, 'spec_many', res.data.specData);
          } else {
            self.$set(self.form.model, 'spec_many', {
              spec_attr: [],
              spec_list: []
            });
            if (res.data.model.sku[0]) {
              self.form.model.sku = res.data.model.sku[0];
            }
          }
          self.form.model.product_status = res.data.model.product_status.value;
          self.form.commission_list = res.data.commission_list;
          // self.form.model.checkedCities = res.data.model.deliveryType;
          self.form.all_type = res.data.all_type;
          self.form.model.attr_type = res.data.model.attr_type
          self.form.model.list = res.data.model.attr_list
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list, type = 1) {
      let obj = {};
      if (type == 2) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_fixed;
        });
      } else if (type == 1) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_equity;
        });
      } else if (type == 20) {
        list.forEach(item => {
          obj[item.grade_id] = item.independent_commission;
        });
      }else if(type == 30){
        list.forEach(item => {
          if(item.product_lateral_ratio){
            obj[item.grade_id] = item.product_lateral_ratio;
          }else{
            obj[item.grade_id] = 0;
          }

        });

      }

      return JSON.stringify(obj);
    },

    /*提交*/
    onSubmit: function () {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = formatModel(self.model, self.form.model);
          params.list = self.form.model.list
          params.scene = self.scene;
          params.image = self.ImgKeepId(params.image);
          params.product_id = self.product_id;
          params.relation_product = self.form.tableData;
          params.relation_label = self.form.labelList;
          params.alone_grade_equity = self.convertJson(self.form.gradeList, params.is_alone_grade);
          params.independent_commission = self.convertJson(self.form.gradeList, params.agent_type);
          params.lateral_ratio = self.convertJson(self.form.gradeList, 30);
          // params.lateral_ratio = '';

          if (params.product_days == '') {
            params.product_days = 0;
          }
          if (params.product_days < 0) {
            self.$message({
              message: '商品有效期不可小于0',
              type: 'error'
            });
            return false;
          }
          self.save_loading = true;
          PorductApi.editProduct(params, true)
            .then(data => {
              self.save_loading = false;
              self.$message({
                message: '保存成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.save_loading = false;
            });
        }
      });
    },

    /*图片数值只保留id*/
    ImgKeepId(list) {
      let arr = [];
      for (let i = 0, length = list.length; i < length; i++) {
        let obj = {
          image_id: list[i].image_id,
          file_id: list[i].file_id
        };
        arr.push(obj);
      }
      return arr;
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/edit.vue